import { render } from "./UserSettingsModal.vue?vue&type=template&id=e9d4a6b6&scoped=true&ts=true"
import script from "./UserSettingsModal.vue?vue&type=script&lang=ts"
export * from "./UserSettingsModal.vue?vue&type=script&lang=ts"

import "./UserSettingsModal.vue?vue&type=style&index=0&id=e9d4a6b6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EugenePrice\\repos\\thinkspatial\\expenses-ionic-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9d4a6b6"]])

export default __exports__